import React from 'react'
import RelatedContacts from './RelatedContacts'
import {titleize} from "../../utils";


/**
 * Match components take an individual entity, either a contact, household or year
 * and render inside a MatchStep component
 * We have separate child components for different match types
 *
 */

class Match extends React.Component {


  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e) {
    this.props.onMatchSelect(e);
  }

  render() {

    // Neat way of inferring the correct component to render based on the entity type
    const matchTypes = {
      'HOUSEHOLD': HouseholdMatch,
      'CHILD': ContactMatch,
      'SIBLING': SiblingMatch,
      'PARENT': ParentMatch,
      'RELATIVE': RelativeMatch,
      'CONSULTANT': ConsultantMatch,
      'YEAR': YearMatch
    };
    // CHILD, HOUSEHOLD1, etc
    const entity = this.props.entity;
    const entityMatch = entity.replace(/\d+$/, "");
    const MatchType = matchTypes[entityMatch];
    const entityType = entityMatch === 'HOUSEHOLD' ? 'household' : 'contact';
    // This is one instance of an entity, either a household or a contact
    const match = this.props.match;
    const contactsToImport = this.props.contactsToImport;
    const idValue = match['id'] ? match['id'] : '0';
    const checked = contactsToImport[entity] === idValue;
    // Sets the header css based on match strength
    let matchColor;
    if (match['strength'] === 'Strong' || match['strength'] === 'Herculean') {
      matchColor = 'form-import-strong'
    } else if (match['strength'] === 'Weak') {
      matchColor = 'form-import-weak'
    } else {
      matchColor = 'form-import-medium'
    }
    // Year matches are handled differently than every other match type
    if (entityMatch != 'YEAR') {
      return (<div className="form-match">
        {match['score'] ?
          <div className={"form-import-match-title " + matchColor}>
            <b> Match: {match['strength']} ({match['score']}) </b></div> :
          <div className="form-import-match-title hint"><b>Form Data</b></div>}
        <div className={match['score'] ? "match-display match-background" : 'match-display'}>
          <MatchType {...this.props} />
          <RelatedContacts match={match} relatedContacts={this.props.relatedContacts}
                           formType={this.props.formType} entity={entity}/>
          <div className="form-import-match-button">
            <label className={checked ? "btn btn-success match-label" : "btn btn-primary match-label"}>
              <i className={checked ? "fa fa-check-square-o white" : "fa fa-square-o"}> </i>
              <input className='d-none' type="radio" name={entity} value={idValue} id={idValue} checked={checked}
                     onChange={this.handleChange}/> {match['score'] ?
              'Merge with this ' + entityType : 'Create a new ' + entityType}
            </label>

          </div>
        </div>
      </div>)
    } else {
      const checked = this.props.contactsToImport['apply_year'] === match['apply_year_name']
      return (        <div className="form-match">
        <div className={match['score'] ? "match-display match-background" : 'match-display'}>
          <MatchType {...this.props} />
          <div className="form-import-match-button">
            <label className={checked ? "btn btn-success match-label white" : "btn btn-primary match-label "}>
              <i className={checked ? "fa fa-check-square-o" : "fa fa-square-o"}> </i>
              <input type="radio" className='d-none' name='apply_year' value={match['apply_year_name']}
                     id={match['apply_year_name']}
                     checked={checked}
                     onChange={this.handleChange}/>
              {match['score'] ? 'Keep the contact in their current term' : 'Move the contact to the term on the form'}
            </label>
          </div>
        </div>
      </div>)
    }
  }
}

/**
 * We have separate child components for each match type so we can specify different
 * formatting. They all use includeKeys, which is just an array of what information from
 * the match hash to output for that type of contact, so we keep a consistent number of rows
 * for each contact type, but don't have contacts showing data they won't have
 * */

class ContactMatch extends React.Component {
  render() {
    const match = this.props.match;
    const formType = this.props.formType;
    const includeKeys = ['apply_year_name', 'display_gender', 'birth_date'];
    return (
      <div>
        <div className="form-import-match"><b>{match['name']}</b></div>
        <div
          className="form-import-match">{match['status'] ? titleize(match['status']) : formType}</div>
        <div className="form-import-match">{match['apply_grade_name']} Grade</div>
        {Object.keys(match).map(function (key) {
          if (includeKeys.includes(key)) {
            return (
              <div className={"form-import-match"}>
                {match[key]}
              </div>
            )
          }
        })}
      </div>
    )
  }
}


class SiblingMatch extends React.Component {
  render() {
    const match = this.props.match;
    /** List of keys we show in the modal with no special handling */
    const includeKeys = ['status', 'display_gender', 'birth_date'];
    const status =["Not In Workflow", "not_in_workflow"].includes(match['status']) ? "Sibling" : match['status'];
    return (
      <div>
        <div className="form-import-match"><b>{match['name']}</b></div>
        <div className="form-import-match"><b>{status}</b></div>
        {Object.keys(match).map(function (key) {
          if (includeKeys.includes(key)) {
            return (
              <div className={"form-import-match"}>
                {match[key]}
              </div>
            )
          }
        })}
      </div>
    )
  }
}

class ParentMatch extends React.Component {
  render() {
    const match = this.props.match;
    const includeKeys = ['phone_1_number', 'phone_2_number', 'phone_3_number', 'email'];
    const status = ["Not In Workflow", "not_in_workflow"].includes(match['status']) ? "Parent" : match['status'];
    return (
      <div>
        <div className="form-import-match"><b>{match['name']}</b></div>
        <div className="form-import-match">{status}</div>
        {Object.keys(match).map(function (key) {
          if (includeKeys.includes(key)) {
            // Make sure we don't show certain fields with special handling
            return (
              <div className={"form-import-match"}>
                {match[key]}
              </div>
            )
          }
        })}
      </div>
    )
  }
}

class RelativeMatch extends React.Component {
  render() {
    const match = this.props.match;
    const includeKeys = ['phone_1_number', 'phone_2_number', 'phone_3_number', 'email'];
    const status = ["Not In Workflow", "not_in_workflow"].includes(match['status']) ? "Relative" : match['status'];
    return (
      <div>
        <div className="form-import-match"><b>{match['name']}</b></div>
        <div className="form-import-match">{status}</div>
        {Object.keys(match).map(function (key) {
          if (includeKeys.includes(key)) {
            // Make sure we don't show certain fields with special handling
            return (
              <div className={"form-import-match"}>
                {match[key]}
              </div>
            )
          }
        })}
      </div>
    )
  }
}

class ConsultantMatch extends React.Component {
  render() {
    const match = this.props.match;
    const includeKeys = ['phone_1_number', 'phone_2_number', 'phone_3_number', 'email'];
    const status = ["Not In Workflow", "not_in_workflow"].includes(match['status']) ? "Consultant" : match['status'];
    return (
      <div>
        <div className="form-import-match"><b>{match['name']}</b></div>
        <div className="form-import-match">{status}</div>
        {Object.keys(match).map(function (key) {
          if (includeKeys.includes(key)) {
            // Make sure we don't show certain fields with special handling
            return (
              <div className={"form-import-match"}>
                {match[key]}
              </div>
            )
          }
        })}
      </div>
    )
  }
}



class HouseholdMatch extends React.Component {
  render() {
    const match = this.props.match;
    const excludeKeys = ['id', 'score', 'strength'];
    return (
      <div>
        {Object.keys(match).map(function (key) {
          // Make sure we don't show the id
          if (!excludeKeys.includes(key)) {
            return (
              <div className={"form-import-match"}>
                {match[key]}
              </div>)
          }
        })}
      </div>

    )
  }
}

class YearMatch extends React.Component {
  render() {
    const match = this.props.match;
    const matchContact = match['score'];
    return (
      <div>
        <div className='form-import-match'> {matchContact ? <b> Keep {match['name']} in {match['apply_year_name']}</b> : <b> Move {match['name']} to {match['apply_year_name']}</b>}
        </div>
        <div className='form-import-match'>
          Grade for this term: {match['apply_grade_name']}
        </div>
        <div className='form-import-match'>
          Status for this term: {match['status'] ? titleize(match['status']) : this.props.formType}</div>
            {matchContact ?
            <div >
            <br/>
              <h3>When should a contact be kept in the same term?</h3><br/>
              <i className="fa fa-user"/> <i className="fa fa-long-arrow-right"/> <i className="fa fa-folder-open-o"/>  A contact should be kept in the same term if they are a <b>current, active</b> applicant or student who filled out an inquiry form by accident
            for a later term. </div>
              : <div>                        <br/><h3>When should a contact be moved to the term on the form?</h3><br/>

                <i className="fa fa-file"/> <i className="fa fa-long-arrow-right"/> <i className="fa fa-folder-open-o"/>    Moving the contact to the term on the form is the default
                behavior. A contact should be moved forward if they are an applicant or inquiry who is interested in re-applying or re-inquiring for a later term. </div>
          }

      </div>

    )

  }
}


export default Match;
